/**
 * Standard page header for clinic-portal modules. Matches the AdminTools shell
 * (eyebrow + display title + intro paragraph + optional actions).
 */
export default function PageShell({ eyebrow, title, intro, actions, children, testId }) {
  return (
    <div className="px-6 lg:px-10 py-8 max-w-7xl" data-testid={testId}>
      <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mb-6">
        <div>
          {eyebrow && (
            <div className="text-[11px] uppercase tracking-[0.22em] font-semibold text-blue-600">{eyebrow}</div>
          )}
          {title && (
            <h1 className="font-display text-3xl lg:text-4xl font-extrabold tracking-tight text-slate-900 mt-1">
              {title}
            </h1>
          )}
          {intro && <p className="text-sm text-slate-500 mt-2 max-w-2xl leading-relaxed">{intro}</p>}
        </div>
        {actions && <div className="shrink-0">{actions}</div>}
      </div>
      {children}
    </div>
  );
}
